import React from 'react';

import './style.css';

const AppItem = ({ app }) => {

  const backgroundStyle = {
    backgroundImage: `url(${app.image})`,
  };

  return (
    <div className="app-item">
      <div className="background-cover" style={backgroundStyle} />
      <div className="app-item-content">
        <div className="picture-container">
          <div className="picture" style={backgroundStyle} />
        </div>
        <div>{app.name}</div>
      </div>
    </div>
  );
};

export default AppItem;


// WEBPACK FOOTER //
// ./src/components/AppItem/index.js